import React from "react";

const BrandList = [
  {
    darkImage: "./images/brand/characterstrong_dark.png",
    lightImage: "./images/brand/characterstrong.png",
    name: "Character Strong",
    url: "https://characterstrong.com/",
  },
  {
    darkImage: "./images/brand/digit_dark.png",
    lightImage: "./images/brand/digit.png",
    name: "Digit Software",
    url: "https://digit-software.com/",
  },
  {
    darkImage: "./images/brand/vega.png",
    lightImage: "./images/brand/vega.png",
    name: "Vega Cloud",
    url: "https://vegacloud.io/",
  },
  {
    darkImage: "./images/brand/NeuRoast.png",
    lightImage: "./images/brand/NeuRoast.png",
    name: "Neuroast",
    url: "https://neuroast.com/",
  },
  {
    darkImage: "./images/brand/gaido.png",
    lightImage: "./images/brand/gaido.png",
    name: "Gaido",
    url: "https://gaidoapp.com/",
  },
  {
    darkImage: "./images/brand/easyJOBFILL_dark.png",
    lightImage: "./images/brand/easyJOBFILL.png",
    name: "easyJOBFILL",
    url: "https://easyjobfill.com/",
  },
  {
    darkImage: "./images/brand/fraudfighter_dark.png",
    lightImage: "./images/brand/fraudfighter.png",
    name: "Fraud Fighter",
    url: "https://fraudfighter.com/",
  },
  {
    darkImage: "./images/brand/safeaccess_dark.png",
    lightImage: "./images/brand/safeaccess.png",
    name: "Safe Access",
    url: "https://safeaccess.ai/",
  },
];

const BrandOne = ({ brandStyle }) => {
  return (
    <ul className={`brand-list ${brandStyle}`}>
      {BrandList.map((data, index) => (
        <li key={index}>
          <a href={data.url} target="_blank">
            <div className="d-flex justify-content-center">
              <img
                className="brand-tint light-img"
                src={`${data.lightImage}`}
                alt={`${data.name} Brand Image`}
              />

              <img
                className="brand-tint dark-img"
                src={`${data.darkImage}`}
                alt={`${data.name} Brand Image`}
              />
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default BrandOne;
